<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/hrg91/tc-custom/FC-9781645366713.jpg?1684514597073?1719602958290" alt="This image is the cover for the book Family Portraits"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Family Portraits
      </h1>
      <p class="bookDescription body article font2">
        <p>After a sunset concert at the pavilion, they walked home by the harbor. Finn asked her to sit for a while with him, and then he declared himself. He took her hand and said, “Molly, my beautiful one, I have loved you from the time I moved into your family’s house. I can’t hold back any longer, and I am asking if you would consider being my wife.”</p><p>Her eyes widened with surprise, and then she said, “I love you more than anything, and I want to be with you forever.”</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        JoAnn Aitken
      </h2>
      
      <p class="authorDescription body article"><p style='margin:0cm;margin-bottom:8.0pt;font-size:15px;font-family:"Arial","sans-serif";text-align:justify;'><span style='font-size:14px;font-family:"Times New Roman","serif";'>JoAnn Aitken has lived all her life in Hamilton, Ontario. She worked for many years at a local community college and has always enjoyed travel. A 2015 trip to Ireland brought together some ideas which became <em>Family Portraits</em>. She describes writing the book as &ldquo;easy&rdquo; once she got started. As the end of the story approached, she found it hard to let go. She hopes her readers will feel the same.</span></p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3a4202a8